import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { articleMetas } from '@/mocks/articlesMeta';

const articleLinks = [
  { slug: 'usfans-legit', path: '/usfans-legit' },
  { slug: 'usfans-spreadsheet-guide', path: '/articles/usfans-spreadsheet-guide' },
  { slug: 'usfans-review', path: '/articles/usfans-review' },
  { slug: 'usfans-shipping-cost', path: '/articles/usfans-shipping-cost' },
  { slug: 'usfans-coupon', path: '/articles/usfans-coupon' },
  { slug: 'usfans-discount-code', path: '/articles/usfans-discount-code' },
  { slug: 'usfans-warehouse', path: '/articles/usfans-warehouse' },
  { slug: 'usfans-qc', path: '/articles/usfans-qc' },
  { slug: 'usfans-beginner-guide', path: '/articles/usfans-beginner-guide' },
  { slug: 'usfans-comparison', path: '/articles/usfans-comparison' },
];

const tagColors: Record<string, string> = {
  tag_safety: 'bg-accent-100 text-accent-700',
  tag_guide: 'bg-primary-100 text-primary-700',
  tag_review: 'bg-secondary-100 text-secondary-700',
  tag_shipping: 'bg-background-200 text-foreground-700',
  tag_coupon: 'bg-primary-100 text-primary-700',
  tag_discount: 'bg-accent-100 text-accent-700',
  tag_warehouse: 'bg-secondary-100 text-secondary-700',
  tag_qc: 'bg-background-200 text-foreground-700',
  tag_beginner: 'bg-primary-100 text-primary-700',
  tag_comparison: 'bg-secondary-100 text-secondary-700',
};

export default function ArticleGrid() {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
      {articleLinks.map((item) => {
        const meta = articleMetas.find((m) => m.slug === item.slug);
        if (!meta) return null;
        const prefix = `article_${item.slug}`;
        const tagKey = meta.tagKey;
        const tagClass = tagColors[tagKey] || 'bg-background-200 text-foreground-700';

        return (
          <Link
            key={item.slug}
            to={item.path}
            className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-transform hover:-translate-y-1"
          >
            <div className="relative h-44 w-full overflow-hidden">
              <img
                src={meta.image}
                alt={t(`${prefix}_title`)}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
            <div className="p-4">
              <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold ${tagClass}`}>
                {t(tagKey)}
              </span>
              <h3 className="mt-2 font-heading text-sm font-bold leading-snug text-foreground-950 md:text-base">
                {t(`${prefix}_title`)}
              </h3>
              <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                {t(`${prefix}_excerpt`)}
              </p>
              <div className="mt-3 flex items-center justify-between text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-calendar-line"></i>
                  {t(`${prefix}_updated`)}
                </span>
                <span className="inline-flex items-center gap-1 font-semibold text-primary-600 group-hover:text-primary-700">
                  {t('read_more')}
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"></i>
                </span>
              </div>
            </div>
          </Link>
        );
      })}
    </div>
  );
}